import FileDownload from "js-file-download";
import { axiosInstance } from "../../../core/sources/network";

import { handleError } from "../../app-messages";
import { getAppStoreCurrentState } from "../../../store";

export const downloadJobseekerResume = ({ jobseekerId, jobseekerName }) => {
  return async (dispatch) => {
    try {
      const { companyProfile } = getAppStoreCurrentState();

      if (companyProfile.currentPlan === "lite") {
        return handleError("Cannot download resume, please upgrade your plan to download resumes.")(dispatch);
      }

      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_BASE_URL}/jobseekers/${jobseekerId}/resumes`,
        {
          responseType: "blob",
        }
      );

      FileDownload(response.data, `${jobseekerName}-resume.pdf`);
    } catch (error) {
      handleError(error?.response?.data?.message ?? error.message)(dispatch);
    }
  };
};
